import React from 'react';
import r2wc from '@r2wc/react-to-web-component';
import LocaleAndThemeProvider from 'src/providers/LocaleAndThemeProvider/LocaleAndThemeProvider';
import { FeatureFlagsProvider } from 'src/providers/FeatureFlagsProvider/FeatureFlagsProvider';
import { FavoriteTripsProvider } from 'src/providers/FavoriteTripsContext/FavoriteTripsContext';
import { BrowserRouter } from 'react-router-dom';
import { QueryProvider } from 'src/providers/QueryProvider';
import MyTrips from 'src/composites/MyTrips/MyTrips';
import { PersonalityTestProvider } from 'src/providers/PersonalityTestProvider';
import { AuthProvider } from 'src/providers/AuthProvider/AuthProvider';

const MyTripsWrapper: React.FC = () => {
  return (
    <AuthProvider>
      <QueryProvider>
        <BrowserRouter>
          <LocaleAndThemeProvider>
            <FeatureFlagsProvider>
              <FavoriteTripsProvider>
                <PersonalityTestProvider>
                  <MyTrips />
                </PersonalityTestProvider>
              </FavoriteTripsProvider>
            </FeatureFlagsProvider>
          </LocaleAndThemeProvider>
        </BrowserRouter>
      </QueryProvider>
    </AuthProvider>
  );
};

const MyTripsComponent = r2wc(MyTripsWrapper);

export default MyTripsComponent;
